<template lang="html">
  <modal name="new-license-modal"
    height="auto" width="416" :maxWidth="416"
    :adaptive="true" transition="pop-out"
    class="new-license-modal"
    @before-open="beforeOpen" @opened="opened"
  >
    <div class="modal-container">
      <div class="modal-header bold">
        Add Licenses
      </div>
      <div class="line-break-gray" />
      <div class="modal-body">
        <div class="descriptor bgap-8">Number of new licenses</div>
        <div class="bgap-24" id="number-of-licenses-dropdown"></div>
        <div class="error-message gap-8" v-if="errors.payment">Number of new licenses</div>
        
        <CouponCode klass="more-licenses" :amount="totalWithoutDiscount" :givenCouponCode="couponCode" inputSize="input-full-width" />

        <div class="flex-box">
          <div class="description-section">
            <div>{{numberOfLicenses}} License</div>
            <div>Prorated savings</div>
            <div>Discount</div>
            <div class="gap-3x" />
            <div class="bold total">Total</div>
          </div>
          <div class="price-section">
            <div>${{licenseCost}}</div>
            <div class="prorated-savings">- ${{proratedSavings}}</div>
            <div class="prorated-savings">- ${{discount}}</div>
            <div class="gap-3x" />
            <div class="bold total">${{total}}</div>
          </div>
        </div>
        <div class="gap-1x" />
        <div class="note">
          All your licenses will expire on {{expires.format("M/D/YYYY")}}, which is one year from your {{explainText}}.
        </div>
      </div>
      <div class="line-break-gray" />
      <div class="modal-footer flex-box">
        <div class="cancel-section">
          <SymbiumButton
            kclass="btn-base dialog-btn"
            :isSmall="true"
            text="Cancel"
            :onClick="() => this.$modal.hide('new-license-modal')"
          />
        </div>
        <SymbiumButton
          kclass="btn-base continue-add-user"
          :isSmall="true"
          :text="continueButtonText"
          :onClick="next"
          :loading="loading"
        />
      </div>
    </div>
  </modal>
</template>

<script>
import SymbiumButton from 'src/components/common/SymbiumButton.vue'
import CouponCode from 'src/components/common/CouponCode.vue'
import EventBus from 'src/components/EventBus.js'
import moment from "moment";

export default {
  components: { SymbiumButton, CouponCode },
  data() {
    return {
      numberOfLicenses: 1,
      expires: moment(),
      discount: 0,
      couponCode: null,
      loading: false,
      errors: {},
      renewed: false,
    }
  },
  methods: {
    beforeOpen(event) {
      this.expires = moment(event.params.expires);
      this.numberOfLicenses = event.params.numberOfLicenses || 1;
      this.renewed = event.params.renewed;
      // this.couponCode = null;
    },
    opened() {
      this.loadNumberOfLicensesDropdown();
    },
    loadNumberOfLicensesDropdown() {
      window.newLicensesModal = this
      const customDropdownScript = document.createElement('script')

      let options = ''
      let n = 0
      while (n < 15) {
        n++
        options = options.concat(`{ id: "${n}", option: "${n}" },`)
      }

      customDropdownScript.text = `
        new MultiDropdown({
          id: "number-of-licenses-dropdown",
          options: [${options}],
          selectOption: (value) => window.newLicensesModal.onNumberOfLicensesChanged(value.id),
          isMulti: false,
          defaultValueIndex: ${this.numberOfLicenses}
        });`
      document.head.appendChild(customDropdownScript)
    },
    onNumberOfLicensesChanged(value) {
      this.numberOfLicenses = value
    },
    afterPurchaseSucessful() {
      this.loading = false
      this.$modal.hide('new-license-modal')
      EventBus.$emit('buildplus-license-purchased')
    },
    afterPurchaseFailed(data) {
      this.errors.payment = data.errors.payment
      this.loading = false;
    },
    next() {
      if(this.isFreePurchase) {
        this.loading = true;
        this.$addMoreLicenseCreditCardCharage(
          null,
          this.numberOfLicenses,
          this.couponCode,
          this.afterPurchaseSucessful,
          this.afterPurchaseFailed,
        );
      } else {
        this.$modal.hide('new-license-modal')
        this.$modal.show('purchase-license-modal', {
          total: this.total,
          numberOfLicenses: this.numberOfLicenses,
          expires: this.expires,
          couponCode: this.couponCode,
          renewed: this.renewed,
        })
      }
    },
    applyCoupon(data) {
      this.discount = data.discount;
      this.couponCode = data.coupon_code;
    }
  },
  computed: {
    licenseCost() {
      return this.numberOfLicenses * 500;
    },
    proratedSavings() {
      if(this.expires) {
        var months = Math.ceil(this.expires.diff(moment(), "months", true))
        return parseInt(((12 - months) / 12.0) * this.licenseCost);
      }
      return 0;
    },
    totalWithoutDiscount() {
      return this.licenseCost - this.proratedSavings;
    },
    total() {
      return this.totalWithoutDiscount - this.discount;
    },
    continueButtonText() {
      if (this.isFreePurchase) {
        return 'Purchase'
      } else {
        return 'Continue'
      }
    },
    isFreePurchase() {
      return this.total < 2
    },
    explainText() {
      return this.renewed ? 'last renewal date' : 'first purchase date'
    }
  },
  watch: {
    numberOfLicenses() {
      EventBus.$emit('cost-changed', this.totalWithoutDiscount)
    }
  },
  created() {
    EventBus.$on('coupon-applied', this.applyCoupon)
  },
  beforeDestroy() {
    EventBus.$off('coupon-applied', this.applyCoupon)
  }
}
</script>

<style lang="scss">

.new-license-modal {
  select.number-of-licenses {
    width: 100%;
    margin-bottom: 16px !important;
  }

  .description-section {
    flex-grow: 1;
  }

  .price-section {
    text-align: right;

    .prorated-savings {
      color: #00A992;
    }
  }

  .total {
    font-size: 24px;
    line-height: 32px;
    letter-spacing: -0.18px;
  }

  .note {
    font-size: 12px;
    line-height: 16px;
  }

  .cancel-section {
    flex-grow: 1;
    text-align: left;
  }

  .continue-add-user {
    min-width: 96px;
  }

  .more-licenses {
    .symbium-form-group {
      width: 100%;
    }
  }

  .more-licenses.coupon-code {
    display: block;
    margin-bottom: 72px;

    .input-container {
      .input-action-icon {
        color: var(--purple);
        cursor: pointer;
        opacity: 0.5;
        top: 13px;
        right: 10px;

        &:hover {
          opacity: 1;
        }

        &.Apply:after {
          content: 'Apply';
        }

        &.Cancel:after {
          content: 'Cancel';
        }

        &.loading:after {
          content: '';
        }
      }
    }

    .calc-left {
      margin-bottom: 8px;
    }
    .calc-right {
      width: 100%;

      input {
        width: 100%;
      }
    }
  }
}
</style>
